import React from "react";
import type { ComponentProps } from "react";

import { Box, HStack, Pressable, Text } from "native-base";
import { Platform } from "react-native";

import type { CellProps } from "pianofunclub-shared/components/Base/Cell";
import { getFullName } from "pianofunclub-shared/utils/extractors";

type HStackProps = ComponentProps<typeof HStack>;

interface Props extends HStackProps {
  hasNote?: boolean;
  onPressDropdown?: () => void;
  pressableTextProps?: CellProps["pressableTextProps"];
  profileFirstName: string | null | undefined;
  profileLastName: string | null | undefined;
  textProps?: CellProps["textProps"];
  userIsTeacher?: boolean;
}

const LessonBlockProfile = (props: Props) => {
  const {
    hasNote,
    onPressDropdown,
    pressableTextProps = {},
    profileFirstName,
    profileLastName,
    textProps = {},
    userIsTeacher,
    ...rest
  } = props;

  return (
    <HStack flex={1} mr="-2" px="1" space="1" width="100%" {...rest}>
      <Text
        {...textProps}
        {...(!userIsTeacher
          ? {
              ...pressableTextProps,
            }
          : {})}
        flex={1}
        isTruncated
      >
        {Platform.OS == "web"
          ? getFullName(profileFirstName, profileLastName)
          : (profileFirstName ?? "")}
      </Text>
      {!userIsTeacher ? (
        <Pressable
          alignItems="center"
          justifyContent="center"
          onPress={onPressDropdown}
          px="1"
          py="3"
        >
          <Box
            bg="transparent"
            borderBottomColor="surface.500"
            borderBottomWidth="9"
            borderLeftColor="transparent"
            borderLeftWidth="6"
            borderRightColor="transparent"
            borderRightWidth="6"
            borderStyle="solid"
            style={{
              transform: [{ rotate: "180deg" }],
            }}
          />
        </Pressable>
      ) : null}
      {hasNote ? (
        <Box
          bg="transparent"
          borderRightColor="transparent"
          borderRightWidth="10"
          borderStyle="solid"
          borderTopColor="primary.500"
          borderTopWidth="10"
          height="0"
          position="absolute"
          right="0"
          style={{
            transform: [{ rotate: "90deg" }],
          }}
          top={Platform.OS === "web" ? "-8" : "-4"}
          width="0"
        />
      ) : null}
    </HStack>
  );
};

export default React.memo(LessonBlockProfile);
